export const ROUTES = {
    splash: "/",
    welcome: "/welcome",
    login: "/login",
    signup: "/signup",
    forgotPassword: "/forgot-password",
    resetPassword: "/reset-password",

    home: "/home",
    categories: "/categories",
    search: "/search",
    productDetails: "/product/:id",
    productDetailsBuild: (id: string) => `/product/${id}`,
    categoryDetail: "/categories/:slug",
    categoryDetailBuild: (slug: string) => `/categories/${slug}`,
    cart: "/cart",
    checkout: "/checkout",
    orderSuccess: "/orders/success/:id",
    orderSuccessBuild: (id: string) => `/orders/success/${id}`,
    orderDetail: "/orders/:id",
    orderDetailBuild: (id: string) => `/orders/${id}`,
    orderPaymentResult: "/orders/:id/payment-result",
    orderPaymentResultBuild: (id: string) => `/orders/${id}/payment-result`,
    orders: "/orders",
    profile: "/profile",

    publicTrack: "/track/:token",

    // Super Admin (legacy /admin/* stays for the console)
    adminLogin: "/admin/login", // kept for redirect back-compat → superAdminLogin
    superAdminLogin: "/superadmin/login",
    adminDashboard: "/admin/dashboard",
    adminProducts: "/admin/products",
    adminProductNew: "/admin/products/new",
    adminProductEdit: "/admin/products/:id",
    adminProductEditBuild: (id: string) => `/admin/products/${id}`,
    adminCategories: "/admin/categories",
    adminInventory: "/admin/inventory",
    adminOrders: "/admin/orders",
    adminOrderDetail: "/admin/orders/:id",
    adminOrderDetailBuild: (id: string) => `/admin/orders/${id}`,
    adminCustomers: "/admin/customers",
    adminCustomerDetail: "/admin/customers/:id",
    adminCustomerDetailBuild: (id: string) => `/admin/customers/${id}`,
    adminCoupons: "/admin/coupons",
    adminLiveMap: "/admin/live-map",
    adminNotifications: "/admin/notifications",
    adminRiders: "/admin/riders",
    adminDispatch: "/admin/dispatch",
    adminStores: "/admin/stores",
    adminTeam: "/admin/team",
    adminActivity: "/admin/activity",
    adminSettlements: "/admin/settlements",
    adminAttendance: "/admin/attendance",
    adminAnalytics: "/admin/analytics",
    adminStoreSettings: "/admin/store-settings",
    adminProfile: "/admin/profile",

    // Operations Admin
    opsLogin: "/ops/login",
    opsDashboard: "/ops/dashboard",

    // Store Admin
    storeLogin: "/store/login",
    storeDashboard: "/store/dashboard",

    // Staff
    staffLogin: "/staff/login",
    staffDashboard: "/staff/dashboard",

    // Rider
    riderLogin: "/rider/login",
    riderDashboard: "/rider/dashboard",
    riderActive: "/rider/active",
    riderEarnings: "/rider/earnings",
    riderHistory: "/rider/history",

    notFound: "*",
} as const;

export type AppRoutePath = (typeof ROUTES)[keyof typeof ROUTES];
